import { cepMask } from 'utils/masks'

function checkFieldExist(string: string | undefined, suffix: string) {
  return !string ? '' : suffix + string
}

function checkCepFieldExist(string?: string) {
  return !string ? '' : ' ' + cepMask(string)
}

export function getFormattedAddress(address: any, prefix?: string): string {
  const emptyString = ''

  if (!address) return ''

  const keyPrefix = prefix ? `${prefix}_` : ''

  const pathnameApartament = emptyString.concat(keyPrefix, 'apartment')
  const pathnameBlock = emptyString.concat(keyPrefix, 'block')
  const pathnameCity = emptyString.concat(keyPrefix, 'city')
  const pathnameCondominium = emptyString.concat(keyPrefix, 'condominium')
  const pathnameCountry = emptyString.concat(keyPrefix, 'country')
  const pathnameNeighbourhood = emptyString.concat(keyPrefix, 'neighbourhood')
  const pathnameNumber = emptyString.concat(keyPrefix, 'number')
  const pathnameState = emptyString.concat(keyPrefix, 'state')
  const pathnameStreet = emptyString.concat(keyPrefix, 'street')
  const pathnameTerritory = emptyString.concat(keyPrefix, 'territory')
  const pathnameZipCode = emptyString.concat(keyPrefix, 'zip_code')
  const pathnameLatitude = emptyString.concat(keyPrefix, 'latitude')
  const pathnameLongitude = emptyString.concat(keyPrefix, 'longitude')

  const sequilizedAddress = {
    apartment: address[pathnameApartament],
    block: address[pathnameBlock],
    city: address[pathnameCity],
    condominium: address[pathnameCondominium],
    country: address[pathnameCountry],
    neighbourhood: address[pathnameNeighbourhood],
    number: address[pathnameNumber],
    state: address[pathnameState],
    street: address[pathnameStreet],
    territory: address[pathnameTerritory],
    zip_code: address[pathnameZipCode],
    latitude: address[pathnameLatitude],
    longitude: address[pathnameLongitude],
  }

  const streat = sequilizedAddress.street
  const number = checkFieldExist(sequilizedAddress.number, ', ')
  const neighbourhood = checkFieldExist(sequilizedAddress.neighbourhood, ' - ')
  const city = checkFieldExist(sequilizedAddress.city, ' - ')
  const state = checkFieldExist(sequilizedAddress.state, ', ')
  const cep = checkCepFieldExist(sequilizedAddress.zip_code)

  const formattedAddress = `${streat}${number}${neighbourhood}${city}${state}${cep}`

  if (!formattedAddress || formattedAddress === 'null' || formattedAddress === 'undefined') return ''

  return formattedAddress
}
